"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ConditionalHelper_1 = require("../helpers/ConditionalHelper");

var isArrayLike_1 = require("../utils/isArrayLike");

var Query_1 = require("./Query");

var utils_1 = require("../utils");

var collection_1 = require("../utils/collection");

var typeChecks_1 = require("../utils/typeChecks");

var BaseCollectionQuery_1 = require("./BaseCollectionQuery");

var DocumentQuery =
/** @class */
function (_super) {
  __extends(DocumentQuery, _super);

  function DocumentQuery() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  DocumentQuery.prototype.initialize = function (executionOptions) {
    this.fillKeyFromQuery('key', 'keyQuery', executionOptions);
  };

  DocumentQuery.prototype.getOptions = function () {
    var _a = this.queryOptions,
        entityType = _a.entityType,
        entityConditional = _a.entityConditional,
        sort = _a.sort,
        index = _a.index,
        startIndex = _a.startIndex,
        endIndex = _a.endIndex,
        collectionItemConditional = _a.collectionItemConditional,
        collectionItemValueConditional = _a.collectionItemValueConditional,
        documentPriority = _a.documentPriority,
        fields = _a.fields,
        key = _a.key,
        keyQuery = _a.keyQuery,
        childKey = _a.childKey,
        _b = _a.options,
        options = _b === void 0 ? {} : _b;
    return __assign({
      entityType: entityType,
      entityConditional: entityConditional,
      sort: sort,
      index: index,
      startIndex: startIndex,
      endIndex: endIndex,
      collectionItemConditional: collectionItemConditional,
      collectionItemValueConditional: collectionItemValueConditional,
      documentPriority: documentPriority,
      fields: fields,
      childKey: childKey,
      key: key,
      keyQuery: keyQuery
    }, options.documents || {});
  };

  DocumentQuery.prototype.getRawValue = function (executionOptions) {
    var _this = this;

    var _a = this.options,
        collectionItemConditional = _a.collectionItemConditional,
        collectionItemValueConditional = _a.collectionItemValueConditional,
        _b = _a.index,
        index = _b === void 0 ? -1 : _b,
        _c = _a.startIndex,
        startIndex = _c === void 0 ? -1 : _c,
        documentPriority = _a.documentPriority;
    var documents = [];

    if (this.options.entityType) {
      documents = this.getSubCollection(executionOptions);
    } else {
      var context = Query_1.Query.getContext(executionOptions, this.queryOptions);

      if (context) {
        var globalDocuments = context.globalDocuments;
        documents = globalDocuments;
      }
    }

    var conditionalHelper = new ConditionalHelper_1.ConditionalHelper({
      conditions: []
    }, this.translationHelper);
    documents = documents.filter(function (document) {
      return !collectionItemConditional || conditionalHelper.matches(document, collectionItemConditional, executionOptions);
    }); // Check against document priority

    if (documentPriority && !typeChecks_1.isNullOrEmpty(documentPriority.joinFields)) {
      var priorityDocuments = [];
      var priorities = documentPriority.priorities,
          joinFields_1 = documentPriority.joinFields,
          _d = documentPriority.ignoreNonPriority,
          ignoreNonPriority = _d === void 0 ? false : _d;
      var groupedDocuments = collection_1.groupBy(documents, function (document) {
        return joinFields_1.map(function (j) {
          return utils_1.get(document, j);
        }).join('-');
      });

      for (var _i = 0, _e = Object.keys(groupedDocuments); _i < _e.length; _i++) {
        var key = _e[_i];
        var currentDocumentList = groupedDocuments[key];
        var foundPriorityDocuments = false;

        var _loop_1 = function _loop_1(priority) {
          var currentPriorityDocuments = currentDocumentList.filter(function (document) {
            return conditionalHelper.matchesWithOptions({
              executionOptions: executionOptions,
              instance: document,
              conditional: priority
            });
          });

          if (!typeChecks_1.isNullOrEmpty(currentPriorityDocuments)) {
            priorityDocuments.push.apply(priorityDocuments, currentPriorityDocuments);
            foundPriorityDocuments = true;
            return "break";
          }
        };

        for (var _f = 0, priorities_1 = priorities; _f < priorities_1.length; _f++) {
          var priority = priorities_1[_f];

          var state_1 = _loop_1(priority);

          if (state_1 === "break") break;
        }

        if (!foundPriorityDocuments && !ignoreNonPriority) {
          priorityDocuments.push.apply(priorityDocuments, currentDocumentList);
        }
      }

      documents = priorityDocuments;
    } // Set up the _fields property with the properties we want


    var response = documents.map(function (document) {
      document._fields = _this.getDocumentResult(document);
      return document;
    });
    var matchingValues = documents.filter(function (value) {
      return !collectionItemValueConditional || conditionalHelper.matchesWithOptions({
        executionOptions: executionOptions,
        instance: value,
        conditional: collectionItemValueConditional
      });
    });

    if (matchingValues && matchingValues.length > 0) {
      response = this.getItem(executionOptions, matchingValues);
    }

    if ((index > -1 || startIndex > -1) && isArrayLike_1.isArrayLike(response)) {
      response = this.getItem(executionOptions, response);
    }

    return response;
  };

  DocumentQuery.prototype.getDocumentResult = function (document) {
    var fields = this.options.fields;

    if (!fields || fields.length === 0) {
      var _a = this.options,
          key = _a.key,
          childKey = _a.childKey;
      return this.getDocumentField(document, key, childKey);
    }

    var documentResult = {};

    for (var _i = 0, fields_1 = fields; _i < fields_1.length; _i++) {
      var field = fields_1[_i];
      var name_1 = field.name,
          key = field.key,
          childKey = field.childKey;
      documentResult[name_1] = this.getDocumentField(document, key, childKey);
    }

    return documentResult;
  };

  DocumentQuery.prototype.getDocumentField = function (document, key, childKey) {
    if (key === void 0) {
      key = null;
    }

    if (childKey === void 0) {
      childKey = null;
    }

    if (document) {
      if (key) {
        var meta = document.meta,
            inferred = document.inferred;

        if (key === 'meta' && meta) {
          return childKey && meta[childKey] && meta[childKey].value;
        }

        if (key === 'inferred' && inferred) {
          return childKey && inferred[childKey] && inferred[childKey].value;
        }

        return document[key];
      }

      return document;
    }

    return;
  };

  return DocumentQuery;
}(BaseCollectionQuery_1.BaseCollectionQuery);

exports.DocumentQuery = DocumentQuery;